import Section from './Section.vue'
import { sortBetRebateTiersByThresholdAsc } from './tierSort'

const REBATE_TYPE_DAY = 1

function createEmptyBetRebateTier() {
  return {
    id: '',
    threshold_yuan: 100,
    gold_yuan: undefined,
    settled_count: 0,
  }
}

function normalizeTierFromApi(tier, ctx) {
  const { centsToYuanNumber } = ctx
  return {
    id: tier?.id != null ? String(tier.id) : '',
    threshold_yuan: centsToYuanNumber(Number(tier?.threshold_amount) || 0),
    gold_yuan: centsToYuanNumber(Number(tier?.gold) || 0),
    settled_count: Number.isFinite(Number(tier?.settled_count)) ? Number(tier.settled_count) : 0,
  }
}

export const lossCashbackModule = {
  type: 7,
  component: Section,
  reset(localForm) {
    localForm.betRebateTiers = [createEmptyBetRebateTier()]
    if (localForm.betRebateRule) {
      localForm.betRebateRule.multiple = 1
    }
    localForm.vips = []
  },
  fillFromActivity(localForm, raw, ctx) {
    const cfg = raw.bet_rebate_config || raw.config || {}
    const rules = cfg.rules && typeof cfg.rules === 'object' ? cfg.rules : {}

    if (localForm.betRebateRule) {
      localForm.betRebateRule.multiple = Number.isFinite(Number(rules.multiple)) ? Number(rules.multiple) : 1
    }

    if (Array.isArray(cfg.vips)) {
      localForm.vips = cfg.vips.map(v => Number(v)).filter(v => Number.isFinite(v))
    }

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    if (rawTiers.length > 0) {
      localForm.betRebateTiers = sortBetRebateTiersByThresholdAsc(
        rawTiers.map(t => normalizeTierFromApi(t, ctx)),
      )
    } else {
      localForm.betRebateTiers = [createEmptyBetRebateTier()]
    }
  },
  validate(localForm, ctx) {
    const { Message, yuanToCents } = ctx
    const mult = Number(localForm.betRebateRule?.multiple)
    if (!Number.isFinite(mult) || mult <= 0) {
      Message.error('请输入大于0的奖励稽核倍数')
      return false
    }

    const tiers = localForm.betRebateTiers || []
    if (tiers.length === 0) {
      Message.error('请至少配置一条亏损档位')
      return false
    }

    for (let i = 0; i < tiers.length; i += 1) {
      const t = tiers[i]
      const row = i + 1
      const th = Number(t.threshold_yuan)
      const g = Number(t.gold_yuan)
      if (!Number.isFinite(th) || th <= 0) {
        Message.error(`第${row}行亏损金额须大于0`)
        return false
      }
      if (!Number.isFinite(g) || g <= 0) {
        Message.error(`第${row}行奖励金额须大于0`)
        return false
      }
    }

    const sortedTiers = sortBetRebateTiersByThresholdAsc(tiers)
    for (let i = 1; i < sortedTiers.length; i += 1) {
      const prev = yuanToCents(Number(sortedTiers[i - 1].threshold_yuan))
      const cur = yuanToCents(Number(sortedTiers[i].threshold_yuan))
      if (cur <= prev) {
        Message.error('亏损档位须按亏损金额从小到大配置，且门槛不能重复或冲突')
        return false
      }
    }
    localForm.betRebateTiers = sortedTiers
    return true
  },
  buildPayload(localForm, ctx) {
    const { yuanToCents } = ctx
    const sorted = sortBetRebateTiersByThresholdAsc(localForm.betRebateTiers || [])
    const tiers = sorted.map((t, idx) => ({
      index: idx + 1,
      threshold_amount: yuanToCents(Number(t.threshold_yuan)) || 0,
      gold: yuanToCents(Number(t.gold_yuan)) || 0,
      settled_count: Number.isFinite(Number(t.settled_count)) ? Number(t.settled_count) : 0,
    }))

    return {
      bet_rebate_config: {
        description: '',
        rules: {
          multiple: Number(localForm.betRebateRule?.multiple) || 0,
          rebate_type: REBATE_TYPE_DAY,
        },
        vips: [...(localForm.vips || [])].sort((a, b) => a - b),
        tiers,
      },
    }
  },
}
